import React from 'react';
import { motion } from 'framer-motion';

const CloseConfirmation = ({ onConfirm, onCancel }) => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex items-center justify-center p-4"
    >
      <motion.div
        initial={{ scale: 0.95, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ type: 'spring', damping: 20 }}
        className="bg-white rounded-xl shadow-xl w-full max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl overflow-hidden"
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-purple-50 to-indigo-50 p-6 border-b border-gray-100">
          <div className="flex justify-center mb-2">
            <div className="bg-purple-100 p-3 rounded-full">
              <svg 
                className="w-6 h-6 text-purple-600" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                />
              </svg>
            </div>
          </div>
          <h2 className="text-xl font-bold text-center text-gray-800">
            Wait! Don't go yet
          </h2>
        </div>

        {/* Body */}
        <div className="p-6 text-center">
          <p className="text-gray-600 mb-6">
            Your cart items might go out of stock soon. Are you sure you want to close?
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="flex-1 px-5 py-3 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium transition-colors"
              onClick={onCancel}
            >
              No, Keep Shopping
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              className="flex-1 px-5 py-3 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white font-medium shadow-md transition-all"
              
              onClick={onConfirm}
              
            >
              Yes, Close Anyway
            </motion.button>
          </div>
        </div>

        {/* Footer */}
        <div className="bg-gray-50 px-6 py-3 text-center border-t border-gray-100">
          <p className="text-xs text-gray-500">
            Changed your mind? You can always come back later!
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default CloseConfirmation;
